module.exports = __webpack_public_path__ + "a98b4502de94295ac57ec0442e0c871c.png";